import config from 'config';
const { METHODS } = config;

export const getMethodNameFromTextButton = (text) => {
  let methodName = text.toLowerCase().replace(/ /g, '_');
  switch (methodName) {
    case 'plant_opn':
      methodName = METHODS.plant_tokens;
      break;
    case 'withdraw':
      methodName = METHODS.withdraw_planted_tokens;
      break;
    case 'revoke':
      methodName = METHODS.revoke_planted_tokens;
      break;
    case 'collect_occ':
      methodName = METHODS.collect_planting_rewards;
      break;
    case 'withdraw_occ':
      methodName = METHODS.withdraw_planting_rewards;
      break;
  }

  return methodName;
};
